import React, { useRef, useState } from "react";
import { ActionButton } from "../../../components";
import { convertToHtml } from "mammoth";

function ImportWordButton({ editor, disabled, icon, tooltip }) {
	const [loading, setLoading] = useState(false);
	const fileInputRef = useRef();
	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const handleFileChange = async (event) => {
		const file = event.target.files[0];
		if (file) {
			setLoading(true);
			try {
				const arrayBuffer = await readFileAsArrayBuffer(file);
				const result = await convertDocxToHtml(arrayBuffer);
				editor.chain().setContent(result, true).run();
			} catch (error) {
				console.error("Error during DOCX to HTML conversion:", error);
				alert("Failed to upload and convert the file. Please try again.");
			} finally {
				setLoading(false);
				event.target.value = null;
			}
		}
	};

	const readFileAsArrayBuffer = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result);
			reader.onerror = () => reject(reader.error);
			reader.readAsArrayBuffer(file);
		});
	};

	const convertDocxToHtml = async (arrayBuffer) => {
		try {
			const { value: html, messages } = await convertToHtml({ arrayBuffer });
			if (messages && messages.length > 0) {
				console.log(messages);
			}
			return html;
		} catch (error) {
			console.error("Mammoth conversion error:", error);
			throw new Error("DOCX to HTML conversion failed.");
		}
	};

	return (
		<div>
			<ActionButton
				loading={loading}
				disabled={disabled}
				icon={icon}
				tooltip={tooltip}
				action={triggerFileInput}
			/>
			<input
				type="file"
				accept=".docx"
				ref={fileInputRef}
				style={{ display: "none" }}
				onChange={handleFileChange}
			/>
		</div>
	);
}

export default ImportWordButton;
